import { WidgetType } from 'widgets/WidgetType';
import ManagedLayout from 'layoutManagement/ManagedLayout';
import {
    createRequestAddWidgetsAction,
    RequestAddWidgetsAction,
} from 'layoutRenderer/store/actions';
import { ThunkDispatch } from 'store/store';
import State from 'store/State';
import Services from 'store/Services';
import { PendingWidgetToAdd } from 'layoutRenderer/LayoutRendererState';

export const requestAddWidgets =
    (widgets: Array<{ widgetType: WidgetType; layout?: ManagedLayout }>) =>
    async (
        dispatch: ThunkDispatch<RequestAddWidgetsAction>,
        getState: () => State,
        services: Services
    ) => {
        const { layoutService } = services;
        const pendingWidgets: PendingWidgetToAdd[] = [];

        for (const widget of widgets) {
            if (!widget.layout) {
                pendingWidgets.push({ widgetType: widget.widgetType });
            } else {
                const dto = await layoutService.fetchLayout(
                    widget.layout.name,
                    widget.widgetType,
                    widget.layout.isGlobal
                );
                const config = JSON.parse(dto.layout);
                pendingWidgets.push({ widgetType: widget.widgetType, config });
            }
        }
        dispatch(createRequestAddWidgetsAction(pendingWidgets));
    };
